export const squareState = {
    method: 'GET',
    paths: ['/redirect/square'],
    fields: {
        sessionUserId: {
            type: 'mongoId',
            required: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
        },
        integrationId: {
            type: 'mongoId',
            required: true,
        },
        url: {
            type: 'url',
            required: true,
        },
        env: {
            type: 'keyString',
            required: true,
        },
    },
};
//# sourceMappingURL=oauth_square_state.js.map